import React from 'react';

import { Container, useMediaQuery, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';

const MobileGuttersContainer = ({ children, className }) => {
  const theme = useTheme();
  const upMd = useMediaQuery(theme.breakpoints.up('md'));

  if (children == null) return null;

  return (
    <Container className={className} disableGutters={upMd}>
      {children}
    </Container>
  );
};

MobileGuttersContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

MobileGuttersContainer.defaultProps = {
  className: null,
  children: null,
};

export default MobileGuttersContainer;
